import type { EnemyKind, EnemyProfile, SpawnItem, Upgrade, UpgradeId } from "../engine/types";

export const ENEMY_PROFILES: Record<EnemyKind, EnemyProfile> = {
  skiff: {
    kind: "skiff",
    name: "Gale Skiff",
    health: 14,
    radius: 27,
    mass: 0.85,
    thrust: 58,
    windResponse: 1.18,
    lateralResponse: 0.2,
    contactDamage: 34,
    score: 120,
    color: "#ef8354"
  },
  stoneback: {
    kind: "stoneback",
    name: "Stoneback",
    health: 48,
    radius: 34,
    mass: 2.2,
    thrust: 42,
    windResponse: 0.22,
    lateralResponse: 0.05,
    contactDamage: 34,
    score: 240,
    color: "#b29b82"
  },
  tacker: {
    kind: "tacker",
    name: "Needle Tacker",
    health: 28,
    radius: 24,
    mass: 1.05,
    thrust: 52,
    windResponse: 0.72,
    lateralResponse: 0.9,
    contactDamage: 34,
    score: 180,
    color: "#d96eb5"
  },
  cinder: {
    kind: "cinder",
    name: "Cinder Kite",
    health: 34,
    radius: 29,
    mass: 1.15,
    thrust: 48,
    windResponse: 0.88,
    lateralResponse: 0.36,
    contactDamage: 34,
    score: 210,
    color: "#f2a23a"
  },
  tempest: {
    kind: "tempest",
    name: "The Red Tempest",
    health: 420,
    radius: 74,
    mass: 3.4,
    thrust: 28,
    windResponse: 0.42,
    lateralResponse: 0.3,
    contactDamage: 50,
    score: 2500,
    color: "#ee4f5f"
  }
};

export const UPGRADES: Record<UpgradeId, Upgrade> = {
  "split-fletching": {
    id: "split-fletching",
    family: "CRAFT",
    name: "Split Fletching",
    description: "Every ready tower fires two parallel bolts instead of one."
  },
  "copper-vanes": {
    id: "copper-vanes",
    family: "HEARTH",
    name: "Copper Vanes",
    description: "Gust instantly reloads every tower and pressure capacity rises by 20."
  },
  "shear-layer": {
    id: "shear-layer",
    family: "CURRENT",
    name: "Shear Layer",
    description: "Bolts curve 80% harder, and curved hits deal 2.5× damage."
  },
  "deep-breath": {
    id: "deep-breath",
    family: "CURRENT",
    name: "Deep Breath",
    description: "Gust costs 40% less and pressure returns 50% faster."
  },
  hearthglass: {
    id: "hearthglass",
    family: "HEARTH",
    name: "Hearthglass",
    description: "Repair 25 integrity and raise the maximum by 15."
  },
  needlecraft: {
    id: "needlecraft",
    family: "CRAFT",
    name: "Needlecraft",
    description: "Towers reload 35% faster and every bolt deals 6 more damage."
  }
};

function arc(kind: EnemyKind, count: number, start: number, spread: number, at: number, interval: number): SpawnItem[] {
  return Array.from({ length: count }, (_, index) => ({
    kind,
    at: at + index * interval,
    angle: start + (count === 1 ? 0 : spread * (index / (count - 1) - 0.5))
  }));
}

export const WAVE_SCHEDULES: SpawnItem[][] = [
  [
    { kind: "skiff", at: 0, angle: 0 },
    ...arc("skiff", 4, Math.PI, 1.25, 2.6, 0.8),
    ...arc("stoneback", 2, Math.PI * 1.5, 0.7, 6.2, 1.1)
  ],
  [
    ...arc("tacker", 4, 0.15, 1.05, 0.4, 0.55),
    ...arc("skiff", 5, Math.PI, 1.05, 0.4, 0.48),
    ...arc("stoneback", 3, Math.PI * 1.5, 0.8, 5.5, 0.8)
  ],
  [
    ...arc("cinder", 5, Math.PI * 0.5, 1.15, 0.4, 0.48),
    ...arc("tacker", 5, Math.PI * 1.25, 1.4, 2.8, 0.48),
    ...arc("stoneback", 4, 0, 1.2, 5.8, 0.7),
    ...arc("skiff", 6, Math.PI, 1.4, 7.8, 0.3)
  ],
  [
    { kind: "tempest", at: 0.8, angle: -Math.PI / 2 },
    ...arc("skiff", 3, Math.PI * 0.8, 0.9, 4.2, 0.7),
    ...arc("tacker", 3, Math.PI * 0.1, 0.8, 8, 0.8),
    ...arc("cinder", 3, Math.PI * 1.4, 0.7, 12, 0.8)
  ]
];
